module.exports = __webpack_public_path__ + "img/empresas-e-promocoes.4bc8ee60.png";